import { StickyBanner } from "@/components/StickyBanner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustBadges } from "@/components/TrustBadges";
import { LiveFeed } from "@/components/LiveFeed";
import { HowItWorks } from "@/components/HowItWorks";
import { ClientJourney } from "@/components/ClientJourney";
import { Testimonials } from "@/components/Testimonials";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="pt-12">
      <StickyBanner />
      <Navbar />
      <main>
        <Hero />
        <TrustBadges />
        <LiveFeed />
        <ClientJourney />
        <HowItWorks />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
